import { generateTestId } from "@client-shared";

export const setOrdersHeaderTestId = (identifier: string): string => generateTestId("OrdersHeader", identifier);

export const setOrdersHeaderContainerTestId = (): string => setOrdersHeaderTestId("container");

export const setOrdersHeaderTitleTestId = (): string => setOrdersHeaderTestId("title");

export const setOrdersHeaderExportButtonTestId = (): string => setOrdersHeaderTestId("export-button");

export const setOrdersHeaderShowSummaryButtonTestId = (): string => setOrdersHeaderTestId("show-summary-button");
